import styled from 'styled-components';
import Colors from 'library/constants/colors';
import { IconBase, SlickArrowStyles, ActionIconListItemBig } from 'library/styles/icon';
import {
  ShadowElevation,
  TransitionConfig,
} from 'library/constants/styles-config';

const Icon = styled(IconBase)`
`;

const Slide = styled.div`
  padding: 0 8px;
  width: auto;
  box-sizing: border-box;

  img {
    max-width: 100%;
    height: 100%;
  }
`;

export const ImageContainer = styled.div`
  max-width: 100%;
`;

export const MainSliderContainer = styled.div`
  margin: auto;
  padding-top: 5vh;
  padding-bottom: 56px;
  
  .slick-track {
    display: flex;
    justify-content: ${({ count }) => (count === 1 ? 'center' : 'start')};
    margin-left: 48px;
  }
  
  .slick-slide {
    opacity: 0;
    transition: opacity ${TransitionConfig};
    
    &.slick-active {
      opacity: 1;

      
    }
  }

  .slick-arrow {
    ${SlickArrowStyles};
  }
`;

export const NavSliderContainer = styled.div`
  .slick-track {
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .slick-slide {
    box-sizing: initial;
    cursor: pointer;
    width: 84px!important;
    
    ${ImageContainer} {
      box-sizing: border-box;
      height: 68px;
      width: 68px;
      overflow: hidden;
      border: 4px solid transparent;
      border-radius: 8px;
      transition: border-color ${TransitionConfig};
    }

    &.slick-current {
      ${ImageContainer} {
        border-color: ${Colors.shade08};
      }
    }

    img {
      object-fit: cover;
      min-width: 100%;
    }
  }
`;

export const ActionIcon = styled(ActionIconListItemBig)`
  position: absolute;
  z-index: 10;
  right: 5%;
  top: 5%;
`;

export const GalleryContainer = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 21;
  opacity: 0;
  transition: opacity ${TransitionConfig};
`;

export const Overlay = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  background-color: rgba(${Colors.shade01Rgb}, 0.8);
`;

export const MainSlide = styled.div`
  height: calc(95vh - 116px - 56px);
  max-width: 90vw;
  width: auto;
  box-sizing: border-box;
  
  ${ImageContainer} {
    height: 100%;
    display: flex;
    align-items: center;    
  }

  img {
    box-shadow: ${ShadowElevation};
    border-radius: 4px;
    max-width: max-content;
    width: auto;
    height: auto;
    max-height: 100%;
  }
`;

export {
  Icon,
  Slide,
};
